export const COUNTIES = [
  'Adams',
  'Alamosa',
  'Arapahoe',
  'Archuleta',
  'Baca',
  'Bent',
  'Boulder',
  'Broomfield',
  'Chaffee',
  'Cheyenne',
  'Clear Creek',
  'Conejos',
  'Costilla',
  'Crowley',
  'Custer',
  'Delta',
  'Denver',
  'Dolores',
  'Douglas',
  'Eagle',
  'El Paso',
  'Elbert',
  'Fremont',
  'Garfield',
  'Gilpin',
  'Grand',
  'Gunnison',
  'Hinsdale',
  'Huerfano',
  'Jackson',
  'Jefferson',
  'Kiowa',
  'Kit Carson',
  'La Plata',
  'Lake',
  'Larimer',
  'Las Animas',
  'Lincoln',
  'Logan',
  'Mesa',
  'Mineral',
  'Moffat',
  'Montezuma',
  'Montrose',
  'Morgan',
  'Otero',
  'Ouray',
  'Park',
  'Phillips',
  'Pitkin',
  'Prowers',
  'Pueblo',
  'Rio Blanco',
  'Rio Grande',
  'Routt',
  'Saguache',
  'San Juan',
  'San Miguel',
  'Sedgwick',
  'Summit',
  'Teller',
  'Washington',
  'Weld',
  'Yuma'];
export const PROPERTY_TYPES = [
  'Single family home',
  'Condo',
  'Townhouse',
  'Multi-unit'];
export const PROPERTY_USES = [
  'Primary residence',
  'Second home',
  'Investment property'];
export const BLANK_COUNTY = 'Choose a county';
export const EMAIL_REGEX = /^[-!#$%&'*+/0-9=?A-Z^_a-z`{|}~](\.?[-!#$%&'*+/0-9=?A-Z^_a-z`{|}~])*@[a-zA-Z0-9](-*\.?[a-zA-Z0-9])*\.[a-zA-Z](-?[a-zA-Z0-9])+$/;
export const PHONE_REGEX = /^((\(\d{3}\) ?)|(\d{3}-))?\d{3}-\d{4}$/;
